module.exports = __webpack_public_path__ + "img/22logo-black.8bd0736a.png";